
<div class="EntityDetailsHeader">
    <div class="entity-icon">
        <i :class="entityIcon"></i>
    </div>
    <div class="entity-info">
        <h2 class="entity-name">{{ entityName }}</h2>
        <p v-if="entitySubtitle" class="entity-subtitle">{{ entitySubtitle }}</p>
    </div>
</div>
